var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerHighschool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_8503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 42.2422C28.6644 42.2422 28.3315 42.1118 28.0738 41.8538L16.9732 30.6218C10.3423 23.9125 10.3423 12.9929 16.9732 6.28366C20.1866 3.03224 24.4577 1.24219 29 1.24219C33.5423 1.24219 37.8134 3.03224 41.0268 6.28366C47.6577 12.9929 47.6577 23.9098 41.0268 30.6218L29.9262 41.8538C29.6711 42.1118 29.3356 42.2422 29 42.2422Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 42.2422C28.6644 42.2422 28.3315 42.1118 28.0738 41.8538L16.9732 30.6218C10.3423 23.9125 10.3423 12.9929 16.9732 6.28366C20.1866 3.03224 24.4577 1.24219 29 1.24219C33.5423 1.24219 37.8134 3.03224 41.0268 6.28366C47.6577 12.9929 47.6577 23.9098 41.0268 30.6218L29.9262 41.8538C29.6711 42.1118 29.3356 42.2422 29 42.2422Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9834 13.2172C25.6287 12.5704 23.7351 12.2536 21.1999 12.2423C20.9608 12.2391 20.7264 12.3088 20.528 12.4422C20.3651 12.5523 20.2317 12.7007 20.1397 12.8744C20.0476 13.0481 19.9996 13.2418 20 13.4384V24.1654C20 24.8906 20.516 25.4376 21.1999 25.4376C23.8648 25.4376 26.538 25.6866 28.1391 27.1998C28.161 27.2206 28.1885 27.2345 28.2182 27.2398C28.248 27.2451 28.2786 27.2415 28.3063 27.2295C28.3341 27.2176 28.3577 27.1977 28.3742 27.1724C28.3907 27.1471 28.3994 27.1176 28.3993 27.0874V14.4477C28.3994 14.3624 28.3811 14.2781 28.3458 14.2005C28.3105 14.1229 28.2589 14.0538 28.1946 13.9978C27.8278 13.6843 27.4204 13.4217 26.9834 13.2172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4705 12.441C37.272 12.308 37.0376 12.2387 36.7986 12.2423C34.2634 12.2536 32.3698 12.5689 31.0151 13.2172C30.5781 13.4213 30.1706 13.6834 29.8036 13.9963C29.7394 14.0524 29.6879 14.1215 29.6527 14.1991C29.6174 14.2767 29.5992 14.361 29.5992 14.4462V27.0866C29.5992 27.1156 29.6077 27.144 29.6238 27.1682C29.6398 27.1924 29.6627 27.2113 29.6894 27.2225C29.7162 27.2338 29.7457 27.2369 29.7742 27.2314C29.8027 27.226 29.8289 27.2123 29.8497 27.192C30.8122 26.2359 32.5015 25.4365 36.8001 25.4369C37.1183 25.4369 37.4235 25.3105 37.6486 25.0854C37.8736 24.8604 38 24.5553 38 24.2371V13.4388C38.0004 13.2418 37.9524 13.0477 37.86 12.8737C37.7677 12.6997 37.6339 12.5511 37.4705 12.441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_8503",
    x: 10.5,
    y: 0.742188,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_8503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_8503",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerHighschool);
export default __webpack_public_path__ + "static/media/marker_highschool.d8b7f327d15084c01cb4bd0720ea980d.svg";
export { ForwardRef as ReactComponent };